"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DataRequest extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dataRequest';
        this._granularity = initParams.granularity;
        this._assetIds = (0, util_1.camelArray)(initParams.asset_ids);
        this._startDate = initParams.start_date;
        this._endDate = initParams.end_date;
        this._status = initParams.status;
        this._size = initParams.size;
        this._dataType = initParams.data_type;
    }
    set granularity(value) {
        console.error('Do not set objects this way');
    }
    get granularity() {
        return this._granularity;
    }
    set assetIds(value) {
        console.error('Do not set objects this way');
    }
    get assetIds() {
        return this._assetIds;
    }
    set startDate(value) {
        console.error('Do not set objects this way');
    }
    get startDate() {
        return this._startDate;
    }
    set endDate(value) {
        console.error('Do not set objects this way');
    }
    get endDate() {
        return this._endDate;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set size(value) {
        console.error('Do not set objects this way');
    }
    get size() {
        return this._size;
    }
    set dataType(value) {
        console.error('Do not set objects this way');
    }
    get dataType() {
        return this._dataType;
    }
    delete() {
        return this.dataService.deleteDataRequest(this.id, this);
    }
}
exports.default = DataRequest;
//# sourceMappingURL=dataRequest.js.map